import { createSelector } from '@reduxjs/toolkit'
import { createStructuredSelector } from 'reselect'

import { PRICE_SELECTED } from 'pu-data/QuoteSteps';
import { extractAssembly } from 'shared/product_tabs/tab_assembly/utils/extracters';

const selectCurrentVariant = (state) => state.assembly?.currentVariant;
const selectLoading = (state) => state.assembly?.loading;
const selectParameters = (state) => state.assembly?.parameters;
const selectQuote = (state) => state.assembly?.quote;
const selectQuoteStep = (state) => state.assembly?.quoteStep;
const selectParametersChanged = (state) => state.assembly?.parametersChanged;
const selectSuppliers = (state) => state.assembly?.suppliers;
const selectDestroy = (state) => state.assembly?.destroy;
const selectLineItemId = (state) => state.assembly?.lineItemId;
const selectAssemblyValidatorFlag = (state) => state.assembly?.validatorFlag;
const selectZipFileInputId = (state) => state.assembly?.zip_file_input_id;
const selectRowSelected = (state) => state.assembly?.parameters?.row_selected;

export const selectAssemblyQuantities = (state) => state.assembly?.parameters?.quantities;

export const selectAssemblyLoading = createStructuredSelector({
  loading: selectLoading,
})

export const selectAssemblyParameters = createStructuredSelector({
  parameters: selectParameters,
  validatorFlag: selectAssemblyValidatorFlag,
})

export const selectAssemblyDataForMatrix = createStructuredSelector({
  parameters: selectParameters,
  quote: selectQuote,
  quoteStep: selectQuoteStep,
  parametersChanged: selectParametersChanged,
  suppliers: selectSuppliers,
})

export const selectAssemblyDataForQuote = createStructuredSelector({
  parameters: selectParameters,
  suppliers: selectSuppliers,
  variant: selectCurrentVariant,
})

export const selectAssemblyDataForValidate = createStructuredSelector({
  parametersChanged: selectParametersChanged,
  quoteStep: selectQuoteStep,
})

export const selectAssemblyDataForCart = createSelector([
    selectParameters,
    selectQuoteStep,
    selectQuote,
    selectDestroy,
    selectLineItemId,
    selectCurrentVariant,
    selectZipFileInputId,
  ],
  (
    parameters,
    quoteStep,
    quote,
    destroy,
    lineItemId,
    currentVariant,
    zip_file_input_id,
  ) => {
    const items_to_destroy = destroy && lineItemId ? [lineItemId] : [];
    const data_for_forms = {quoteStep, assemblyVariant: currentVariant, parameters, zip_file_input_id}

    return {
      assemblyProps: extractAssembly({ quoteStep, parameters, quote, currentVariant }),
      assemblyToDestroy: items_to_destroy,
      assemblyDataForForms: data_for_forms,
    }
  }
)

export const selectAssemblySelectedQuantity = createSelector([
    selectAssemblyQuantities,
    selectRowSelected,
    selectQuoteStep,
  ],
  (
    quantities,
    row_selected,
    quoteStep,
  ) => {
    const default_quantity = quantities && quantities.length > 0 ? quantities[0] : null;
    if(!quoteStep || quoteStep != PRICE_SELECTED) return default_quantity;

    return row_selected && default_quantity ? quantities[row_selected] : default_quantity;
  }
)

